import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import DataTable from 'react-data-table-component';
import { Breadcrumbs, Image } from '../../../../../AbstractElements';
import { Col, Container, Form, FormGroup, Input, Label, Row, Card, CardBody, Nav, NavItem, NavLink, Media, Button, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, Modal, ModalHeader, ModalBody, ModalFooter, Table, Badge } from 'reactstrap';
import { MoreVertical, PlusCircle, ChevronDown, ChevronUp, Upload, TrendingUp, Eye } from 'react-feather';
import axios from 'axios';
import 'react-dropdown/style.css';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import { baseURL, imageURL, productBaseURL } from '../../../../../Services/api/baseURL';
import dummyImg from '../../../../../assets/images/product/2.png';
import Loader from '../../../../Loader/Loader';
import CategoryCountCard from '../../../../CategoryCountCard';
import "./style.scss"
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { FaPen, FaPlus, FaTrashAlt } from 'react-icons/fa';
import moment from 'moment';
import { debounce } from 'lodash';
import exportExcelData from '../../Reports/components/exportExcelData'
import useRbac from '../../../../../Hooks/useRbac'

const ViewStore = () => {
  const { can, canAny } = useRbac();
  const navigate = useNavigate();
  const { storeName } = useParams();
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [selectedRows, setSelectedRows] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [subCollectionData, setSubCollectionData] = useState([])
  const [collectionData, setCollectionData] = useState([])
  const [countData, setCountData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [BasicTab, setBasicTab] = useState(1);
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);
  const [subCollectionValue, setSubCollectionValue] = useState("");
  const [show, setShow] = useState(false);
  const [showProducts, setShowProducts] = useState(false);
  const [showVariants, setShowVariants] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductVariant, setSelectedProductVariant] = useState(null);
  const [calculatedValue, setCalculatedValue] = useState(1);
  const [stockId, setStockId] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [isAdd, setIsAdd] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [sortType, setSortType] = useState("asc")
  const [sortField, setSortField] = useState("number_of_products")
  const [addLoading, setAddLoading] = useState(false);
  const [subCollectionName, setSubCollectionName] = useState('');
  const [activeTabName, setActiveTabName] = useState('All Products')
  const isSortingRef = useRef(false);

  const formik = useFormik({
    initialValues: {
      store_id: id,
      category_id: "",
      sub_category_id: "",
      product_id: "",
      number_of_products: 0,
      minimum_qty: 0,
      reason_for_inventory: "",
    },
    validationSchema: Yup.object({
      category_id: Yup.string().required('Category is required'),
      sub_category_id: Yup.string().required('Subcategory is required'),
      product_id: Yup.string().required('Product is required'),

      number_of_products: Yup.number().moreThan(-1, 'Please enter valid No. of product').required('Product is required'),
      minimum_qty: Yup.number().moreThan(0, 'Please enter valid No. of Quantity').required('Minimum Quantity is required'),
      reason_for_inventory: Yup.string().required('Please select Reason for Inventory'),
    }),
    onSubmit: async (values) => {
      const token = await JSON.parse(localStorage.getItem("token"));
      let resp;
      setAddLoading(true);
      try {
        if (stockId && !isAdd) {
          resp = await axios.patch(`${baseURL}/api/admin/update-stock/${stockId}`, formik.values, {
            headers: {
              Authorization: `${token}`
            }
          });
        }
        else {
          resp = await axios.post(`${baseURL}/api/admin/add-stock`, formik.values, {
            headers: {
              Authorization: `${token}`
            }
          });
        }
        if (resp?.status === 200) {
          Swal.fire({
            icon: "success",
            title: resp?.data?.message
          });
          setShow(false);
          fetchStocksList();
          getCountData();
          setAddLoading(false);
        }
      }
      catch (error) {
        setAddLoading(false);
      }
    }
  });

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleChange = (name, value) => {
    formik.setFieldValue(name, value);
    formik.setFieldValue("product_id", "");
    setSelectedProduct(null);
  }

  const getCountData = async () => {
    const token = await JSON.parse(localStorage.getItem("token"));
    try {
      await axios.get(`${baseURL}/api/admin/get-store-counts/${id}`, {
        headers: {
          Authorization: `${token}`,
        }
      }).then((response) => {
        if (response.status === 200) {
          let updatedData = response?.data?.data;
          setCountData(updatedData[0]);
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  const fetchCategoryList = async () => {
    const token = await JSON.parse(localStorage.getItem("token"))
    try {
      const collectData = await axios.get(`${baseURL}/api/admin/get-collections?page=1&limit=1000`, {
        headers: {
          Authorization: `${token}`,
        }
      });
      let data = collectData?.data?.data.filter((item) => item.status === "active")
      setCollectionData(data)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubcollectionsList = async () => {
    const token = await JSON.parse(localStorage.getItem("token"))
    try {
      const response = await axios.get(`${baseURL}/api/admin/get-sub-collections?page=1&limit=1000`, {
        headers: {
          Authorization: `${token}`
        }
      })
      let data = response?.data?.data.filter((item) => item.status === "active")
      setSubCollectionData(data)

    } catch (error) {
      console.log(error)
    }
  }

  const fetchItems = async () => {
    setIsLoading(true);
    const token = await JSON.parse(localStorage.getItem("token"))
    try {
      const products = await axios.get(`${productBaseURL}/products/get-products`, {
        headers: {
          Authorization: `${token}`,
        }
      })
      if (products) {
        setProductsData(products.data.data)
        setIsLoading(false)
      }

    } catch (error) {
      setIsLoading(false)
    }
    finally {
      setIsLoading(false);
    }
  }

  const fetchStocksList = async (
    page = 1,
    limit = perPage,
    sortField = "createdAt",
    sortOrder = "desc"
  ) => {
    setIsLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = {
        page,
        limit,
        order_by: sortField,
        order_type: sortOrder,
        ...(searchTerm ? { search_string: searchTerm } : {}),
        ...(selectedCollectionId ? { category_id: selectedCollectionId } : {}),
        ...(subCollectionValue ? { subCategory_id: subCollectionValue } : {}),
      };

      const resp = await axios.get(
        `${baseURL}/api/admin/get-stocks-by-storeId/${id}`,
        { params, headers: { Authorization: token } }
      );

      setStockData(resp.data.data);
      setTotalRows(resp.data.count);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (isSortingRef.current) {
      return;
    }
    fetchStocksList(page, perPage, sortField, sortType);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    fetchStocksList(page, newPerPage, sortField, sortType);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const debouncedHandleSearch = useCallback(debounce(handleSearch, 300), []);

  useEffect(() => {
    if (isSortingRef.current) {
      return;
    }
    setCurrentPage(1);
    fetchStocksList(1, perPage, sortField, sortType);
  }, [selectedCollectionId, subCollectionValue, searchTerm]);


  useEffect(() => {
    getCountData();
    fetchCategoryList();
    fetchSubcollectionsList();
    fetchItems();
    fetchStocksList();
  }, []);

  const handleNavigateEdit = (id) => {
    navigate(`/product/edit/${id}`);
  }

  const handleSort = (column, sortDirection) => {
    const newSortField = column.sortField || "createdAt";
    const newSortType = sortDirection;
    isSortingRef.current = true;
    setSortField(newSortField);
    setSortType(newSortType);
    setCurrentPage(1);
    fetchStocksList(1, perPage, newSortField, newSortType);
    setTimeout(() => {
      isSortingRef.current = false;
    }, 100);
  };

  const handleAll = () => {
    setBasicTab(1);
    setSelectedCollectionId(null);
    setSubCollectionValue("");
    fetchStocksList();
    setActiveTabName('All Products');
  }

  const handleTabs = async (data, index) => {
    setBasicTab(index + 2);
    setSelectedCollectionId(data?._id);
    setSubCollectionValue("");
    setActiveTabName(data.collection_name)
  }

  const handleSubCollectionChange = (e) => {
    let value = e.target.value;
    setSubCollectionValue(value)
  }

  const handleProductToggle = () => {
    setShowProducts(!showProducts);
  }

  const handleVariantToggle = () => {
    setShowVariants(!showVariants);
  }

  const handleProductData = (data) => {
    setCalculatedValue(null);
    setSelectedProductVariant(null);
    setShowVariants(false);
    formik.setFieldValue('product_id', data?._id);
    setSelectedProduct(data);
    setShowProducts(false);
  }

  const uploadCsv = async (file) => {
    setIsLoading(true);
    const token = await JSON.parse(localStorage.getItem("token"));
    const store_id = id
    if (store_id !== undefined || store_id !== "") {
      try {
        const formData = new FormData();
        formData.append('csv', file)
        const res = await axios.post(`${baseURL}/api/csv/import-stock/${store_id}`,
          formData, {
          headers: {
            Authorization: `${token}`,
          }
        })
        if (res) {
          fetchStocksList();
          getCountData();
          setIsLoading(false);
        }
      } catch (err) {
        console.log(err)
        setIsLoading(false)
      }
    }
  }

  const getEditData = async (stockId, isAddMode = false) => {
    const token = await JSON.parse(localStorage.getItem("token"));
    if (stockId) {
      try {
        const response = await axios.get(
          `${baseURL}/api/admin/get-stocks-by-stockId/${stockId}`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        );
        if (response.status === 200) {
          let resp = response?.data.data;
          let data = resp;
          data?.category_id && formik.setFieldValue('category_id', data?.category_id);
          data?.sub_category_id && formik.setFieldValue("sub_category_id", data.sub_category_id);
          data?.product_id && formik.setFieldValue("product_id", data.product_id);
          isAddMode
            ? formik.setFieldValue("number_of_products", 0)
            : formik.setFieldValue("number_of_products", data?.number_of_products || 0);

          data.minimum_qty && formik.setFieldValue("minimum_qty", data.minimum_qty);
          data.reason_for_inventory && formik.setFieldValue("reason_for_inventory", data.reason_for_inventory);
          setSelectedProduct(data?.product_info[0]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleModalToggle = () => {
    if (show) {
      formik.resetForm();
      setStockId("");
      setSelectedProduct(null);
      setIsAdd(false);
    }
    setShow(!show);
  };
  const handleAddModalToggle = () => {
    if (show) {
      formik.resetForm();
      setStockId("");
      setSelectedProduct(null);
      setIsAdd(false);
    }
    setShow(!show);
  };

  const filteredProducts = productsData.filter(item => {
    if (formik.values.category_id && formik.values.sub_category_id) {
      return (
        item.category?._id === formik.values.category_id &&
        item.subCategory?._id === formik.values.sub_category_id
      );
    }
    else if (formik.values.category_id) {
      return item.category?._id === formik.values.category_id;
    }
    else {
      return true;
    }
  });

  const handleViewInventoryLog = async (id) => {
    navigate(`/store/view-inventory-log/${id}`);
  }
  const handleVariantsSalesLog = async (id) => {
    navigate(`/store/view-variants-sales/${id}`);
  }

  const deleteStock = async (id) => {
    if (window.confirm(`Are you sure you want to delete this Stock ?`)) {
      try {
        const token = await JSON.parse(localStorage.getItem("token"))
        await axios.delete(`${baseURL}/api/admin/stock/delete/${id}`, {
          headers: {
            Authorization: `${token}`,
          }
        }).then((res) => {
          Swal.fire({
            icon: "success",
            title: res?.data?.message,
          })
          getCountData();
          fetchStocksList();
        })
      }
      catch (err) {
        console.error(err)
      }
    }
  }

  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.number_of_products;
    const b = rowB.number_of_products;
    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const fetchAllStocksForExport = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const params = {
        page: 1,
        limit: totalRows,
        order_by: sortField,
        order_type: sortType,
        ...(searchTerm ? { search_string: searchTerm } : {}),
        ...(selectedCollectionId ? { category_id: selectedCollectionId } : {}),
        ...(subCollectionValue ? { subCategory_id: subCollectionValue } : {}),
      };

      const resp = await axios.get(
        `${baseURL}/api/admin/get-stocks-by-storeId/${id}`,
        { params, headers: { Authorization: token } }
      );

      return resp.data.data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const downloadExcelData = async () => {
    setIsLoading(true);
    try {
      const allStockData = await fetchAllStocksForExport();

      if (allStockData.length === 0) {
        Swal.fire({
          icon: "info",
          title: "No data to export"
        });
        setIsLoading(false);
        return;
      }
      exportExcelData(allStockData, subCollectionName, storeName, activeTabName);
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export failed",
        text: "An error occurred while exporting data"
      });
    } finally {
      setIsLoading(false);
    }
  };

  const tableColumns = [
    {
      name: 'PRODUCT',
      selector: row => row['product_id'],
      cell: (row) => (
        <>
          <Media className='d-flex'><Image attrImage={{ className: 'img-30 me-3', src: `${row?.product_info[0]?.variants.length > 0 ? imageURL + row?.product_info[0]?.variants[0]?.variantImage : dummyImg}`, alt: 'Generic placeholder image' }} />
            <Media body className="align-self-center">
              <div style={{
                whiteSpace: "normal",
                overflow: "hidden",
                wordBreak: "break-word",
                display: "inline-block",
                width: "100%",
                lineHeight: "1.2",
                cursor: "pointer",
                color: "#007bff",
                textDecoration: "underline",
              }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/store/product/${row._id}`, {
                    state: {
                      product: row?.product_info[0],
                      storeId: id
                    },
                  });
                }} >{row?.product_info[0]?.productName}</div>
            </Media>
          </Media>
        </>
      ),
      sortable: true,
      center: true,
    },
    {
      name: 'NO. OF PRODUCTS',
      selector: row => row['number_of_products'],
      sortable: true,
      sortField: "number_of_products",
      center: false,
    },
    {
      name: 'SUB CATEGORY',
      selector: row => `${row.sub_category_id}`,
      cell: (row) => (
        <>
          {row?.subcategory_info[0]?.sub_collection_name}
        </>
      ),
      sortable: true,
      center: true,
    },
    {
      name: 'CREATED DATE',
      selector: row => `${row.designation}`,
      sortable: true,
      center: true,
      cell: (row) => (
        <>
          {moment(row?.createdAt).format('DD MMM, YYYY')}
        </>
      ),
    },
    {
      name: 'STOCK',
      selector: row => row['priority'],
      cell: (row) => (
        <>
          <span style={{ fontSize: '13px' }} className={row?.number_of_products === 0 ? 'badge badge-light-danger' : row?.number_of_products < row?.minimum_qty ? 'badge badge-light-warning' : 'badge badge-light-success'}>
            {row?.number_of_products === 0 ? 'Out of Stock' : row?.number_of_products < row?.minimum_qty ? 'Low Stock' : 'In-Stock'}
          </span>

        </>
      )
      ,
      sortable: true,
      center: true,
      sortFunction: caseInsensitiveSort,
    },
    {
      name: 'Actions',
      omit: !canAny(['stock.create', 'stock.update', 'stock.delete']),
      cell: (row) => (
        <div className='d-flex justify-content-end align-items-center' style={{ marginRight: '20px' }}>
          <div
            className='cursor-pointer'
          >
            <UncontrolledDropdown className='action_dropdown'>
              <DropdownToggle className='action_btn'
              >
                <MoreVertical color='#000' size={16} />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => {
                  setIsAdd(true);
                  setStockId(row?._id);
                  getEditData(row?._id, true);
                  setShow(true);
                }}>
                  Add
                  <FaPlus />
                </DropdownItem>
                <DropdownItem onClick={() => {
                  setIsAdd(false); // Add this line
                  setStockId(row?._id);
                  getEditData(row?._id, false);
                  setShow(true);
                }}>
                  Edit
                  <FaPen />
                </DropdownItem>
                <DropdownItem className='delete_item' onClick={() => deleteStock(row?._id)}>
                  Delete
                  <FaTrashAlt />
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      ),
      right: true,
    }
  ];

  const loading = isLoading || !stockData || stockData.length === 0;


  return (
    <Fragment>
      <Breadcrumbs mainTitle={storeName !== (undefined || 'undefined') ? storeName : "View Store"} parent='Store' title={storeName !== (undefined || 'undefined') ? storeName : "View Store"} />
      <CategoryCountCard data={countData} />
      <Card>
        <CardBody style={{ padding: '15px' }}>
          <Row xxl={12} className='pb-2'>
            <Col md={12} lg={12} xl={12} xxl={12}>
              <div>
                <Nav tabs className='product_variant_tabs mb-3'>
                  <NavItem>
                    <NavLink className={BasicTab === 1 ? 'active' : ''} onClick={() => handleAll()}>
                      All Products
                    </NavLink>
                  </NavItem>
                  {
                    collectionData.length > 0 && (
                      collectionData.sort((a, b) =>
                        a.collection_name.localeCompare(b.collection_name)).slice(0, 20).map((data, index) => {
                          return (
                            <Fragment key={index}>
                              <NavItem key={data?._id || index}>
                                <NavLink className={BasicTab === (index + 2) ? 'active' : ''} onClick={() => handleTabs(data, index)}>
                                  {data.collection_name}
                                </NavLink>
                              </NavItem>
                            </Fragment>
                          )
                        })
                    )
                  }
                </Nav>
              </div>
            </Col>
            <Col md={12} lg={12} xl={12} xxl={12}>
              <div className="file-content file-content1 justify-content-between">
                <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                  <i className='fa fa-search' style={{ top: 'unset' }}></i>
                  <input className='form-control border-0' onChange={(e) => debouncedHandleSearch(e.target.value)} type='text' placeholder='Search...' />
                </div>
                <div className='d-flex'>
                  <Input type='select' className='ms-3' name='subCategory' value={subCollectionValue} onChange={(e) => {
                    const selectedOption = subCollectionData.find(item => item._id === e.target.value);
                    handleSubCollectionChange(e);
                    setSubCollectionName(selectedOption ? selectedOption.sub_collection_name : undefined);
                  }} >
                    <option>Select Sub Category</option>
                    {
                      selectedCollectionId ? (
                        subCollectionData.length > 0 && subCollectionData.filter((item) => item?.collection_id?._id === selectedCollectionId).map((data) => {
                          return (
                            <option key={data?._id} value={data?._id}>{data?.sub_collection_name}</option>
                          );
                        })
                      ) : (
                        subCollectionData.map((data) => {
                          return (
                            <option key={data?._id} value={data?._id}>{data?.sub_collection_name}</option>
                          );
                        })
                      )
                    }
                  </Input>

                  <div className='d-flex align-items-center'>
                    {/* Dropdown for actions */}
                    <UncontrolledDropdown className='ms-1'>
                      <DropdownToggle
                        tag="button"
                        className='btn btn-primary d-flex align-items-center gap-1'
                        style={{ minWidth: '120px' }}
                      >
                        <span>More actions</span>
                        <ChevronDown size={14} />
                      </DropdownToggle>
                      <DropdownMenu className='absolute right-0 top-10 z-50 bg-white border border-gray-100 rounded-xl shadow-xl w-52 py-1' >
                        {/* <DropdownItem onClick={() => {
                          formik.resetForm();
                          setStockId("");
                          setSelectedProduct(null);
                          setIsAdd(true);
                          setShow(true);
                        }}>
                          <span className='d-flex align-items-center gap-2 mt-1' style={{ whiteSpace: 'nowrap' }}>
                            <PlusCircle size={14} />
                            Add New Stock
                          </span>
                        </DropdownItem> */}

                        <DropdownItem onClick={() => handleViewInventoryLog(id)}>
                          <span className='d-flex align-items-center gap-2 mt-1' style={{ whiteSpace: 'nowrap' }}>
                            <Eye size={14} />
                            View Inventory Log
                          </span>
                          {/* <span>View Inventory Log</span> */}
                        </DropdownItem>

                        <DropdownItem onClick={() => handleVariantsSalesLog(id)}>
                          <span className='d-flex align-items-center gap-2 mt-1' style={{ whiteSpace: 'nowrap' }}>
                            <TrendingUp size={14} />
                            Variants Sales Data
                          </span>
                        </DropdownItem>

                        <DropdownItem onClick={() => {
                          navigate(`/store/revenue/${id}`);
                        }}>
                          <span className='d-flex align-items-center gap-2 mt-1' style={{ whiteSpace: 'nowrap' }}>
                            <TrendingUp size={14} />
                            View Revenue
                          </span>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    <Button
                      className='btn btn-primary d-flex align-items-center ms-1'
                      style={{ minWidth: '136px' }}
                      onClick={() => {
                        formik.resetForm();
                        setStockId("");
                        setSelectedProduct(null);
                        setIsAdd(true);
                        setShow(true);
                      }}
                    >
                      <PlusCircle />
                      <span className="ms-2">Add New Stock</span>
                    </Button>

                    {/* Import from CSV */}
                    <Label htmlFor='csv' className='btn mb-0 btn-primary d-flex align-items-center ms-1 btn btn-secondary' style={{ minWidth: '136px' }}>
                      <Input
                        id='csv'
                        type='file'
                        accept=".csv"
                        className='d-none'
                        onChange={(e) => uploadCsv(e.target.files[0])}
                      />
                      <Upload />
                      <span className="ms-2">Import CSV</span>
                    </Label>

                    {/* Export Excel */}
                    <Button type='button' className='btn btn-primary d-flex align-items-center ms-1' style={{ minWidth: '136px' }} onClick={downloadExcelData}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                        <path d="M9.33882 8.82071L9.33871 8.82059L9.32968 8.82962L8.125 10.0341V5.75L11.687 5.75C11.6871 5.75 11.6872 5.75 11.6874 5.75C12.1348 5.75058 12.5637 5.92857 12.8801 6.24494C13.1965 6.56141 13.3745 6.99049 13.375 7.43803V15.562C13.3745 16.0095 13.1965 16.4386 12.8801 16.7551C12.5636 17.0715 12.1345 17.2495 11.687 17.25H2.31303C1.86549 17.2495 1.43641 17.0715 1.11994 16.7551C0.803539 16.4387 0.625547 16.0097 0.625 15.5622V7.43778C0.625547 6.99032 0.80354 6.56135 1.11994 6.24494C1.43631 5.92857 1.86523 5.75058 2.31263 5.75C2.31277 5.75 2.3129 5.75 2.31303 5.75L5.875 5.75V10.0341L4.67032 8.82962L4.67043 8.8295L4.66118 8.82071C4.44849 8.61864 4.16527 8.50765 3.87192 8.51141C3.57855 8.51516 3.29827 8.63337 3.09082 8.84082C2.88337 9.04827 2.76516 9.32856 2.76141 9.62191C2.75765 9.91527 2.86864 10.1985 3.07071 10.4112L3.07059 10.4113L3.07965 10.4204L6.20465 13.5454L6.20477 13.5455C6.41572 13.7563 6.70176 13.8747 7 13.8747C7.29824 13.8747 7.58428 13.7563 7.79523 13.5455L7.79535 13.5454L10.9204 10.4204L10.9205 10.4205L10.9293 10.4112C11.1314 10.1985 11.2423 9.91527 11.2386 9.62191C11.2348 9.32855 11.1166 9.04827 10.9092 8.84082C10.7017 8.63337 10.4214 8.51516 10.1281 8.51141C9.83473 8.50765 9.55151 8.61864 9.33882 8.82071ZM7.08839 0.786612C7.11183 0.810053 7.125 0.841847 7.125 0.875V4.75H6.875V0.875C6.875 0.841849 6.88817 0.810054 6.91161 0.786612C6.93505 0.763169 6.96685 0.75 7 0.75C7.03315 0.75 7.06495 0.76317 7.08839 0.786612Z" fill="white" stroke="white" />
                      </svg>
                      <span className="ms-2">Export</span>
                    </Button>
                  </div>
          
                </div>
              </div>
            </Col>
          </Row>

          <DataTable
            data={stockData || []}
            columns={tableColumns}
            // selectableRows
            onSelectedRowsChange={handleRowSelected}
            clearSelectedRows={toggleDelet}
            progressPending={isLoading || stockData === null}
            progressComponent={<Loader />}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onSort={handleSort}
            sortServe
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            noDataComponent="No records to display"
          />
        </CardBody>
      </Card>

      <Modal isOpen={show} toggle={isAdd ? handleAddModalToggle : handleModalToggle} className={"stock_modal"} size='lg' centered>
        <ModalHeader className='d-flex' toggle={isAdd ? handleAddModalToggle : handleModalToggle}>
          {stockId && !isAdd ? 'Update Stock' : 'Add Stock'}  {formik.values.number_of_products < formik.values.minimum_qty && <Badge className='ms-2' color="warning">
            Low Stock
          </Badge>}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={formik.handleSubmit}>
            <Container>
              <Row xxl={12} className='mt-2'>
                <Col md={6}>
                  <FormGroup>
                    <Label className='font-medium text-base'>Category <span className='text-danger'>*</span> </Label>
                    <Input
                      type="select"
                      name='category_id'
                      onChange={(e) => handleChange('category_id', e.target.value)}
                      onBlur={formik.handleBlur}
                      value={formik.values.category_id}
                      invalid={formik.touched.category_id && formik.errors.category_id ? true : false}
                    >
                      <option value="">Select Category</option>
                      {
                        collectionData.length !== 0 && collectionData.map(item => (
                          <Fragment key={item?._id}>
                            <option value={item._id} >{item.collection_name}</option>
                          </Fragment>
                        ))
                      }
                    </Input>
                    {formik.touched.category_id && formik.errors.category_id ? (
                      <span className="error text-danger">{formik.errors.category_id}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className='font-medium text-base'>Subcategory <span className='text-danger'>*</span></Label>
                    <Input
                      type="select"
                      name='sub_category_id'
                      onChange={(e) => handleChange('sub_category_id', e.target.value)}
                      // onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.sub_category_id}
                      invalid={formik.touched.sub_category_id && formik.errors.sub_category_id}
                    >
                      <option>Select Sub Category</option>
                      {
                        subCollectionData.length > 0 &&
                        subCollectionData.filter((item => item?.collection_id?._id === formik.values.category_id)).map((data) => {
                          return (
                            <Fragment key={data?._id}>
                              <option value={data?._id} >{data?.sub_collection_name}</option>
                            </Fragment>
                          )
                        })
                      }
                    </Input>
                    {formik.touched.sub_category_id && formik.errors.sub_category_id ? (
                      <span className="error text-danger">{formik.errors.sub_category_id}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className='font-medium text-base'>Product <span className='text-danger'>*</span></Label>
                    <div className='position-relative'>
                      <div className='form-control select-product' onClick={() => handleProductToggle()}>
                        {selectedProduct ? (
                          <Row className='product_data mb-0 p-0 border-0'>
                            <Col lg={2}>
                              <div className='product_img'>

                                <img src={selectedProduct?.variants[0]?.variantImage ? imageURL + selectedProduct?.variants[0]?.variantImage : dummyImg} />
                              </div>
                            </Col>
                            <Col lg={10}>
                              <div className='product_text'>
                                {selectedProduct?.productName}
                              </div>
                            </Col>
                          </Row>
                        ) : 'Select Product'}
                        {showProducts ? <ChevronUp /> : <ChevronDown />}
                      </div>
                      {
                        showProducts && (
                          <div className='product_wrapper'>
                            {
                              filteredProducts.map((data) => {
                                return (
                                  <>
                                    <Row key={data?._id} className='product_data' onClick={() => handleProductData(data)}>
                                      <Col lg={2}>
                                        <div className='product_img'>
                                          <img src={data?.variants[0]?.variantImage ? imageURL + data?.variants[0]?.variantImage : dummyImg} />
                                        </div>
                                      </Col>
                                      <Col lg={10}>
                                        <div className='product_text'>
                                          {data.productName}
                                        </div>
                                      </Col>
                                    </Row>
                                  </>
                                )
                              })
                            }
                            {
                              filteredProducts.length === 0 && <p className='mb-0 text-center'>No Data Found</p>
                            }
                          </div>
                        )
                      }
                    </div>
                    {formik.touched.product_id && formik.errors.product_id ? (
                      <span className="error text-danger">{formik.errors.product_id}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>


                <Col md={6}>
                  <FormGroup>
                    <Label className='font-medium text-base'>No. of Product <span className='text-danger'>*</span></Label>
                    <Input placeholder='Enter No. of Product' name='number_of_products'
                      type='number'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.number_of_products}
                      invalid={formik.touched.number_of_products && formik.errors.number_of_products} />
                    {formik.touched.number_of_products && formik.errors.number_of_products ? (
                      <span className="error text-danger">{formik.errors.number_of_products}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className='font-medium text-base'>Required Minimum Quantity <span className='text-danger'>*</span></Label>
                    <Input placeholder='Enter Minimum Quantity'
                      name='minimum_qty'
                      type='number'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.minimum_qty}
                    />
                    {formik.touched.minimum_qty && formik.errors.minimum_qty ? (
                      <span className="error text-danger">{formik.errors.minimum_qty}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Reason for Inventory <span className='text-danger'>*</span> </Label>
                    <Input type='select' name='reason_for_inventory' onChange={formik.handleChange} value={formik.values.reason_for_inventory} onBlur={formik.handleBlur}
                    >
                      <option>Select Reason for Inventory</option>
                      <option value='Stock Received'>Stock Received</option>
                      <option value='Transfer'>Transfer</option>
                      <option value='Damaged in-store by staff handling'>Damaged in-store by staff handling</option>
                      <option value='Received damaged inventory from supplier'>Received damaged inventory from supplier</option>
                      <option value='Return to store'>Return to store</option>
                      <option value='Stock Count'>Stock Count</option>
                      <option value='Exchange'>Exchange</option>
                      <option value='Promotion and discount'>Promotion & Discount</option>
                    </Input>
                    {formik.touched.reason_for_inventory && formik.errors.reason_for_inventory ? (
                      <span className="error text-danger">{formik.errors.reason_for_inventory}</span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>

                <Col lg={12}>
                  {
                    selectedProduct && selectedProduct?.variants && selectedProduct?.variants.length > 0 &&
                    <>
                      {
                        <>
                          <Table border responsive>
                            <thead>
                              <tr>
                                <th>
                                  Quantity
                                </th>
                                <th>
                                  Product
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                selectedProduct?.variants.map((data, index) => {
                                  return (
                                    <>
                                      <tr key={index}>
                                        <td scope="row">
                                          <span className='quantity_count'>
                                            {data.quantity !== 0 ? (!isNaN(parseInt(formik.values.number_of_products / data.quantity)) ?parseInt(formik.values.number_of_products / data.quantity) : 0) : 0} *
                                          </span>
                                        </td>
                                        <td>
                                          <div className='d-flex align-items-center'>
                                            <div className='product_img'>
                                              <img style={{ width: '30px', height: '30px' }} src={data?.variantImage ? imageURL + data?.variantImage : dummyImg} />
                                            </div>
                                            <div className='product_text ms-2'>
                                              {data?.variantName}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  )
                                })
                              }

                            </tbody>
                          </Table>
                        </>
                      }
                    </>
                  }
                </Col>
              </Row>
            </Container>
            <ModalFooter>
              <Button className='cancel_Btn' onClick={handleModalToggle} >Cancel</Button>
              <Button className='Save_Btn' disabled={addLoading} type='submit'> {stockId && !isAdd ? 'Update Stock' : 'Add Stock'}</Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment >
  )
}
export default ViewStore